const TableHead = ({ columns, handleSorting, sortField, sortOrder }) => {
  const getSortIcon = (accessor) => {
    if (accessor !== sortField) return "↕️";
    return sortOrder === "asc" ? "▲" : "▼";
  };

  return (
    <thead>
      <tr className="bg-gray-100">
        {columns.map(({ label, accessor }) => (
          <th
            key={accessor}
            onClick={() => handleSorting(accessor)}
            className="text-start align-middle px-3 py-2 border cursor-pointer user-select-none"
          >
             <div className="d-flex justify-content-between align-items-center">
              <span>{label}</span>
              
              <span className="text-gray-500 fs-12">
                {getSortIcon(accessor)}
              </span>
            </div>
          </th>
        ))}
      </tr>
    </thead>
  );
};
export default TableHead;